import l from "./_castPath.js";
import f from "./_toKey.js";
function d(n, e) {
  e = l(e, n);
  for (var r = 0, i = e.length; n != null && r < i; )
    n = n[f(e[r++])];
  return r && r == i ? n : void 0;
}
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseGet.js
// module id = 905
// module chunks = 67